var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1C4.63438 1 1.5 4.13438 1.5 8C1.5 11.8656 4.63438 15 8.5 15C12.3656 15 15.5 11.8656 15.5 8C15.5 4.13438 12.3656 1 8.5 1ZM12.1687 12.5078L3.99219 4.33125C4.24219 4.02344 4.52344 3.74219 4.83125 3.49219L13.0078 11.6687C12.7578 11.975 12.4766 12.2578 12.1687 12.5078Z",
    fill: "#EC1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopFilled);
export default __webpack_public_path__ + "static/media/stopFilled.8b9cd6e8e388c6542c4774b3d6aff151.svg";
export { ForwardRef as ReactComponent };